import { useEffect, useState } from "react";
import { useTask } from "../../../../hooks/query";
import { useResponsive } from "../../../../hooks";
import { API_ENDPOINTS } from "../../../../constants";

import { DesktopView } from "./desktop";
import { MobileView } from "./mobile";
import { IPropertyPhotos, roofingPhotoSections } from "./types";

export function PropertyPhotos({ taskDetails }: IPropertyPhotos) {
    const { useListAssets } = useTask();
    const listAssetsSvc = useListAssets();
    const { isMobile } = useResponsive();

    const [imageGroups, setImageGroups] = useState<any>([]);
    const [expandedAlbum, setExpandedAlbum] = useState<string | null>(null);

    const fetchAndGroup = async () => {
        try {
            if (!taskDetails.Id) return;

            const response = await listAssetsSvc.mutateAsync({
                TaskId: taskDetails.Id,
                AssetType: "TASK:INITIAL_INSPECTION",
            });

            const grouped = roofingPhotoSections.map((section) => {
                const sectionAssets = response.filter((img: any) => img.Label === section.label);
                return {
                    ...section,
                    images: sectionAssets.map((asset: any) => ({
                        url: API_ENDPOINTS.asset.getImageAsSrc(asset.AssetId),
                        assetId: asset.AssetId,
                        note: asset.Note || null,
                    })),
                };
            });

            setImageGroups(grouped);
        } catch (e) {
            console.error(e);
        }
    };

    // Fetch assets from the server and group them by section
    useEffect(() => {
        fetchAndGroup();
    }, [taskDetails.Id]);

    const toggleAlbum = (id: string) => {
        setExpandedAlbum((prev) => (prev === id ? null : id));
    };

    if (isMobile) {
        return (
            <MobileView
                imageGroups={imageGroups}
                taskId={taskDetails.Id}
                projectId={taskDetails.ProjectId}
                expandedAlbum={expandedAlbum}
                onToggleAlbum={toggleAlbum}
            />
        );
    }

    return <DesktopView imageGroups={imageGroups} taskId={taskDetails.Id} projectId={taskDetails.ProjectId} />;
}

// Export the generic type just in case.
export * from "./types";
